import React from 'react';

import RouteComponent from 'components/routes/RouteComponent';
import PrivateRoute from 'components/routes/PrivateRoute';

const RouteFromPath = ({ ...route }) =>
  route.private ? <PrivateRoute {...route} /> : <RouteComponent {...route} />;

export default RouteFromPath;
